import { render, staticRenderFns } from "./AggridClient.vue?vue&type=template&id=1023953e"
import script from "./AggridClient.vue?vue&type=script&lang=js"
export * from "./AggridClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports